import { css, Theme } from '@emotion/react'
import { chipClasses, inputBaseClasses } from '@mui/material'

export const freeSoloFormControlLabel = (theme: Theme) => css`
  display: flex;
  flex-direction: column-reverse;

  width: 100%;
  margin: 0;
  align-items: initial;
  gap: 10px;

  & > .MuiTypography-root {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${theme.typographyColors.typographyThree};
  }

  & .${inputBaseClasses.root} {
    padding: 7px 14px;
    border: none;
    height: auto;
    border-radius: 14px;

    background-color: transparent;

    border: 1px solid ${theme.colors.backgroundOne};

    box-shadow: 0px 2px 2px -1px rgba(138, 148, 166, 0.13);

    .${inputBaseClasses.input} {
      padding: 4px 0 5px;
    }

    &.${inputBaseClasses.focused} {
      border-color: ${theme.colors.blue};
    }

    &.${inputBaseClasses.error} {
      border-color: ${theme.colors.red};
    }
  }

  .${chipClasses.root} {
    margin: 0;
    border-radius: 12px;
    border: 1px solid ${theme.colors.backgroundOne};
    box-shadow: 0px 2px 2px -1px rgba(138, 148, 166, 0.13);

    font-weight: 500;
  }
`
